/**
 * Formatierungs-Utilities für die AIQCON Energy Platform
 * Alle Formate auf den deutschen Markt ausgelegt
 */

export const formatPrice = (priceInEurPerKwh) => {
  if (priceInEurPerKwh == null) return '–';
  const ctPerKwh = priceInEurPerKwh * 100;
  return ctPerKwh.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const formatPriceCt = (priceInCtPerKwh) => {
  if (priceInCtPerKwh == null) return '–';
  return priceInCtPerKwh.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const formatCurrency = (amountInEur) => {
  if (amountInEur == null) return '–';
  return amountInEur.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const formatConsumption = (kwh) => {
  if (kwh == null) return '–';
  return kwh.toLocaleString('de-DE') + ' kWh';
};

export const formatPercent = (value) => {
  if (value == null) return '–';
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }) + ' %';
};

export const formatDate = (date) => {
  if (!date) return '–';

  // Reine Kalendertage ("2027-01-01") liest der JS-Parser als UTC-Mitternacht.
  // toLocaleDateString rechnet danach in die lokale Zeit zurueck — westlich von
  // UTC erscheint dadurch der Vortag. Vertragsbeginn, Lieferbeginn und
  // Bindefristen sind aber reine Datumsangaben ohne Uhrzeit, deshalb bauen wir
  // sie hier direkt aus ihren Bestandteilen.
  const nurTag = typeof date === 'string' && /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (nurTag) return `${nurTag[3]}.${nurTag[2]}.${nurTag[1]}`;

  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '–';
  return d.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatDateTime = (date) => {
  if (!date) return '–';
  return new Date(date).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatRelativeTime = (date) => {
  if (!date) return '–';
  const now = new Date();
  const diff = now - new Date(date);
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (minutes < 1) return 'gerade eben';
  if (minutes < 60) return `vor ${minutes} Min.`;
  if (hours < 24) return `vor ${hours} Std.`;
  if (days < 7) return `vor ${days} Tagen`;
  return formatDate(date);
};

export const generateOfferNumber = () => {
  const now = new Date();
  const year = now.getFullYear();
  const seq = Math.floor(Math.random() * 9000) + 1000;
  return `AQ-${year}-${seq}`;
};

export const generateSlug = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const segments = [];
  for (let s = 0; s < 3; s++) {
    let segment = '';
    for (let i = 0; i < 4; i++) {
      segment += chars[Math.floor(Math.random() * chars.length)];
    }
    segments.push(segment);
  }
  return segments.join('-');
};
